const VOICES: [string, boolean][] = [
  // Windows Desktop Chrome
  ['Microsoft Haruka Desktop - Japanese', true],
  // Windows Desktop Firefox
  ['urn:moz-tts:sapi:Microsoft Haruka Desktop - Japanese?ja-JP', true],
  // Windows Store Edge
  ['Microsoft Haruka - Japanese (Japan)', true],
  ['Microsoft Ayumi - Japanese (Japan)', true],
  // MacOS Safari
  ['com.apple.speech.synthesis.voice.kyoko.premium', false],
  ['com.apple.speech.synthesis.voice.kyoko', false],
  // MacOS Chrome
  ['Kyoko', false],
  // MacOS Firefox
  ['urn:moz-tts:osx:com.apple.speech.synthesis.voice.kyoko.premium', false],
  ['urn:moz-tts:osx:com.apple.speech.synthesis.voice.kyoko', false],
  // iOS Safari & Chrome
  ['com.apple.ttsbundle.Kyoko-premium', false],
  ['com.apple.ttsbundle.Kyoko-compact', false],
  ['com.apple.ttsbundle.siri_female_ja-JP_premium', false],
  ['com.apple.ttsbundle.siri_female_ja-JP_compact', false],
];

export let DEFAULT_VOICE: SpeechSynthesisVoice | undefined;
export let VOICE_NEWLINE_RECOGNISABLE = false;

function initVoice() {
  if (typeof window.speechSynthesis === 'object') {
    const voices = speechSynthesis.getVoices();
    if (voices.length === 0) {
      speechSynthesis.addEventListener('voiceschanged', initVoice);
      return;
    }
    for (const [uri, recognisable] of VOICES) {
      for (const voice of voices) {
        if (voice.voiceURI === uri) {
          DEFAULT_VOICE = voice;
          VOICE_NEWLINE_RECOGNISABLE = recognisable;
          return;
        }
      }
    }
  }
}

initVoice();
